import { render, staticRenderFns } from "./qianbao03_list.vue?vue&type=template&id=5f9c5651&scoped=true"
import script from "./qianbao03_list.vue?vue&type=script&lang=js"
export * from "./qianbao03_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9c5651",
  null
  
)

export default component.exports